module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0027.jpg?v=b5bf05ec";